import { render, staticRenderFns } from "./FacultyLeaveSettings.vue?vue&type=template&id=43c72d18&scoped=true"
import script from "./FacultyLeaveSettings.vue?vue&type=script&lang=js"
export * from "./FacultyLeaveSettings.vue?vue&type=script&lang=js"
import style0 from "./FacultyLeaveSettings.vue?vue&type=style&index=0&id=43c72d18&prod&scoped=true&lang=css"
import style1 from "./FacultyLeaveSettings.vue?vue&type=style&index=1&id=43c72d18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c72d18",
  null
  
)

export default component.exports